import type { Product, PublicConfig, SiteSettings } from "../shared/types";
import { fallbackCatalog, fallbackSettings } from "../shared/catalog";

const API_ORIGIN = (import.meta.env.VITE_API_ORIGIN || "").replace(/\/$/, "");

export async function apiJson<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${API_ORIGIN}${path}`, {
    ...options,
    headers: {
      ...(options?.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
      ...options?.headers
    }
  });
  const payload = await response.json().catch(() => ({ error: "The server returned an unreadable response." }));
  if (!response.ok) {
    throw new Error(payload.error || `Request failed with status ${response.status}.`);
  }
  return payload as T;
}

export async function loadStorefront(): Promise<{
  products: Product[];
  settings: SiteSettings;
  config: PublicConfig;
  source: "api" | "fallback";
}> {
  try {
    const [catalog, config] = await Promise.all([
      apiJson<{ products: Product[]; settings: SiteSettings }>("/api/catalog"),
      apiJson<PublicConfig>("/api/config")
    ]);
    return { ...catalog, config, source: "api" };
  } catch {
    return {
      products: fallbackCatalog,
      settings: fallbackSettings,
      config: { checkoutEnabled: false, turnstileSiteKey: null, shippingConfigured: false },
      source: "fallback"
    };
  }
}
